"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_TASK_BASE_URL = void 0;
/* tslint:disable:max-file-line-count */
const styled_1 = __importDefault(require("@emotion/styled"));
const diem_1 = __importDefault(require("@travelnest/diem"));
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const __1 = require("../../../..");
const pricing_1 = require("../../../../entities/pricing");
const helpers_1 = require("../../../../entities/pricing/helpers");
const viewstate_1 = require("../../../../entities/viewstate");
const actionCallback_1 = require("../../../../hooks/actionCallback");
const autosave_1 = require("../../../../hooks/autosave");
const useCustomer_1 = __importDefault(require("../../../../hooks/useCustomer"));
const constants_1 = require("../../../../tasks/constants");
const Button_1 = require("../../../components/button/Button");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const InlineMessage_1 = require("../../../components/inline-message/InlineMessage");
const Label_1 = require("../../../components/input/label/Label");
const PricingPeriodGap_1 = require("../../../components/pricing-period/PricingPeriodGap");
const PricingPeriodSummary_1 = require("../../../components/pricing-period/PricingPeriodSummary");
const Spacer_1 = require("../../../components/spacer/Spacer");
const TaskPage_1 = require("../../base/TaskPage");
const Generator_1 = require("./Generator");
const helpers_2 = require("./helpers");
const smart_pricing_task_validation_1 = require("./smart-pricing-task-validation");
const PricingPeriodPage_1 = require("./PricingPeriodPage");
const CurrencyChoiceModal_1 = require("../../../components/currency-choice-modal/CurrencyChoiceModal");
const pricingPeriods_1 = require("../../../../hooks/validation/pricingPeriods");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const logging_1 = require("../../../../logging");
const fullStory_1 = require("../../../../util/fullStory");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const Paragraph_1 = require("../../../components/paragraph/Paragraph");
const HelpLink_1 = require("../../../components/help-link/HelpLink");
const SmartPricingSummary_1 = require("../../../components/smart-pricing/SmartPricingSummary");
const SmartPricingEdit_1 = require("./SmartPricingEdit");
const calendar_svg_1 = __importDefault(require("../../../components/smart-pricing/calendar.svg"));
const smart_pricing_modals_1 = require("../../../components/smart-pricing-modals");
const ValidationContext_1 = require("../../../../context/ValidationContext");
const TaskCompletenessContext_1 = require("../../../../context/TaskCompletenessContext");
const SmartPricingChecklist_1 = require("../../../../view/components/smart-pricing/SmartPricingChecklist");
const GradientInfoCard_1 = require("../../../components/gradient-info-card/GradientInfoCard");
const hui_1 = require("@travelnest/hui");
const H2_1 = require("../../../../view/components/typography/H2");
const H4_1 = require("../../../../view/components/typography/H4");
const P_1 = require("../../../../view/components/typography/P");
const pricing_helpers_1 = require("../../../../util/pricing_helpers");
const SmartPricingRecapData_1 = require("../../../components/pricing-smart-recap/SmartPricingRecapData");
exports.PRICING_TASK_BASE_URL = '/tasks/pricing';
const ButtonWrapper = styled_1.default.div `
	margin-top: 24px;

	button {
		display: inline-block;
		margin-bottom: ${theme_1.default.layout.spacing.standard};
		margin-right: ${theme_1.default.layout.spacing.standard};
	}
`;
const PricingListSpacer = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(Spacer_1.Spacer, null),
    react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
    react_1.default.createElement(Spacer_1.Spacer, null)));
const SmartPricingButtonContainer = styled_1.default.div `
	display: flex;
	margin: 8px 0;
	gap: 16px;
`;
const SmartPricingRecapDataWrapper = styled_1.default.div `
	width: 100%;
	margin-top: 32px;
	margin-bottom: 16px;
`;
exports.default = (props) => {
    var _a;
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions, appMode } = (0, react_1.useContext)(__1.AppContext);
    const { state: validationState } = (0, react_1.useContext)(ValidationContext_1.ValidationContext);
    const { state: taskCompletenessState } = (0, react_1.useContext)(TaskCompletenessContext_1.TaskCompletenessContext);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { property, viewState: propertyViewState } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const manualPricing = (0, autosave_1.useAutoSavePricing)(props.propertyId);
    const pricingDefaults = (0, autosave_1.useAutoSavePricingDefaults)(props.propertyId);
    const smartPricing = (0, react_redux_1.useSelector)((state) => state.data.pricingAutomaticPrices.byPropertyId[props.propertyId]);
    const pricingOverrides = (0, react_redux_1.useSelector)((state) => state.data.pricingOverrides.byPropertyId[props.propertyId]);
    const pricingDefault = (0, react_redux_1.useSelector)((state) => state.data.pricingDefaults.byPropertyId[props.propertyId]);
    const { pricingType, viewState: pricingTypeViewState, update: updatePricingType, } = (0, autosave_1.useAutoSavePricingType)(props.propertyId);
    const { pathname } = (0, react_router_dom_1.useLocation)();
    // Clear editing state if the use navigates back (via browser button or link)
    react_1.default.useEffect(() => {
        if (pathname.endsWith(exports.PRICING_TASK_BASE_URL)) {
            if (editingPeriod && otherPeriods) {
                const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)([
                    ...otherPeriods,
                    editingPeriod,
                ]);
                manualPricing.update(updatedDepartureDays);
                setEditingPeriod(null);
                setOtherPeriods(null);
            }
        }
    }, [pathname]);
    const [chosenCurrency, setChosenCurrency] = react_1.default.useState(helpers_1.CurrencyCodes.GBP);
    // If there is an existing currency choice, OR default price is already set, set it here
    react_1.default.useEffect(() => {
        if (manualPricing.pricing && manualPricing.pricing.length > 0) {
            setChosenCurrency(manualPricing.pricing[0].currency);
            setCurrencyChoiceMade(true);
        }
    }, [manualPricing.pricing]);
    // If pricing type is automatic, the currency choice for the property will always have been made
    react_1.default.useEffect(() => {
        if (pricingType && pricingType.type === 'automatic') {
            setCurrencyChoiceMade(true);
        }
        if (!smartPricing && (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic') {
            dispatch(entityActions.pricingAutomaticPrices.getByPropertyId(props.propertyId));
        }
        if (!pricingOverrides && (pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) === 'automatic') {
            dispatch(entityActions.pricingOverrides.getByPropertyId(props.propertyId));
        }
    }, [pricingType]);
    const pricingValidation = (0, react_redux_1.useSelector)((state) => state.data.pricingValidation.byPropertyId[props.propertyId]);
    // When pricing or pricing type are updated, refresh the validation
    (0, actionCallback_1.useActionCallback)(() => {
        dispatch(entityActions.pricingValidation.getByPropertyId(props.propertyId));
    }, 'PRICING_UI_UPDATE_RECEIVE', 'PRICING_TYPE_UPSERT_BY_PROPERTY_ID_RECEIVE');
    // When a user opts out of smart pricing, we need to perform the following side effects:
    // - Re-fetch the manual pricing they have
    // - Update the pricing validation state for the property.
    const [smartPricingOptOutResyncLoading, setSmartPricingOptOutResyncLoading,] = react_1.default.useState(false);
    (0, actionCallback_1.useActionCallback)(() => {
        dispatch(entityActions.pricingUi.getByPropertyId(props.propertyId));
    }, 'PRICING_TYPE_UPSERT_BY_PROPERTY_ID_RECEIVE', 'PRICING_TYPE_UPSERT_BY_PROPERTY_ID_FAILURE');
    (0, actionCallback_1.useActionCallback)(() => {
        setSmartPricingOptOutResyncLoading(false);
    }, 'PRICING_UI_GET_BY_PROPERTY_ID_RECEIVE', 'PRICING_UI_GET_BY_PROPERTY_ID_FAILURE');
    const sortedPricing = (manualPricing.pricing || []).sort((a, b) => (0, helpers_2.sortDates)(a.start_date, b.start_date));
    const { current: currentPricing, past: pastPricing } = (0, helpers_2.splitPricingIntoPastAndCurrent)(sortedPricing);
    const currentPricingAndGapsList = (0, helpers_2.sortedPricingAndGaps)(currentPricing || []);
    const noCurrentOrFuturePricing = currentPricingAndGapsList.length === 0;
    // Inverted so that most recent past pricing period will be shown first
    const pastPricingSorted = pastPricing.sort((a, b) => (0, helpers_2.sortDates)(a.start_date, b.start_date) * -1);
    // When editing, this state is used to split up the currently-editing period from the rest
    const [editingPeriod, setEditingPeriod] = react_1.default.useState();
    const [otherPeriods, setOtherPeriods] = react_1.default.useState();
    const [showPastPricingPeriods, setShowPastPricingPeriods] = react_1.default.useState(false);
    const [generatorModalOpen, setGeneratorModalOpen] = react_1.default.useState(false);
    const [currencyChoiceMade, setCurrencyChoiceMade] = react_1.default.useState(false);
    const [smartPricingModalOpen, setSmartPricingModalOpen] = react_1.default.useState(false);
    const [smartPricingOptOutModalOpen, setSmartPricingOptOutModalOpen] = react_1.default.useState(false);
    const chosenDefaultPrice = undefined;
    // this is what we serve all customers on split.io
    const smartPricingValue = pricing_1.SMART_RATE.every_2_days;
    const [smartPricingRegionCheckLoading, setSmartPricingRegionCheckLoading] = react_1.default.useState(true);
    const [smartPricingRegionSupported, setSmartPricingRegionSupported] = react_1.default.useState();
    // Determine whether this property is eligible for Smart Pricing
    react_1.default.useEffect(() => {
        const checkRegionSupport = () => __awaiter(void 0, void 0, void 0, function* () {
            const { id, latitude, longitude } = property;
            setSmartPricingRegionCheckLoading(true);
            (0, helpers_2.fetchSmartPricingRegionCheck)(id, latitude, longitude)
                .then((resp) => setSmartPricingRegionSupported(resp.in_market))
                .catch((err) => console.error(err))
                .finally(() => setSmartPricingRegionCheckLoading(false));
        });
        if ((pricingType === null || pricingType === void 0 ? void 0 : pricingType.type) !== 'automatic') {
            console.debug('Checking region support in effect');
            checkRegionSupport();
        }
        else {
            console.debug('Not running smart pricing region check for property');
            setSmartPricingRegionCheckLoading(false);
        }
    }, [pricingType, property]);
    // sets the properties defaults entity for editing smart pricing defaults
    const [editingDefaults, setEditingDefaults] = react_1.default.useState(false);
    // determines which view the user will see based on pricing type and whether they are editing
    const pricingTypePageMode = () => {
        let mode = editingPeriod ? 'MANUAL_EDIT' : 'MANUAL';
        if (pricingType && pricingType.type === 'automatic') {
            mode = editingDefaults ? 'SMART_EDIT' : 'SMART';
        }
        return mode;
    };
    const handleAddPeriodClick = () => {
        var _a;
        let startDate = new diem_1.default(); // Today
        if (pricingValidation &&
            pricingValidation.end &&
            !noCurrentOrFuturePricing) {
            startDate = new diem_1.default(pricingValidation.end);
            startDate.setDate(startDate.getDate() + 1);
        }
        const newPeriod = (0, helpers_2.newPricingPeriod)(props.propertyId, chosenCurrency, startDate);
        setEditingPeriod(newPeriod);
        setOtherPeriods(manualPricing.pricing);
        if (!((_a = manualPricing.pricing) === null || _a === void 0 ? void 0 : _a.length)) {
            (0, fullStory_1.sendCustomFullStoryEvent)('pricing_input_method', {
                manual: true,
            });
        }
        const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)([
            newPeriod,
            ...(manualPricing.pricing || []),
        ]);
        manualPricing.update(updatedDepartureDays);
    };
    const AddPeriodButton = ({ text }) => (react_1.default.createElement(Button_1.Button, { onClick: handleAddPeriodClick }, text));
    const hasExistingPricing = !!(manualPricing.pricing && manualPricing.pricing.length > 0) &&
        !noCurrentOrFuturePricing;
    const customer = (0, useCustomer_1.default)(props.customerId);
    const isPropertyUnpublished = !property.published_version;
    const smartPricingTasksValidation = (0, smart_pricing_task_validation_1.smartPricingTasksValidationFactory)(isPropertyUnpublished, validationState, taskCompletenessState);
    // strict equality needed as valid can be true, false OR 'REVIEW_REQUIRED'
    const smartPricingTasksValid = Object.values(smartPricingTasksValidation).every((valid) => valid === true);
    // Delighted survey to be shown when a host opts out of smart pricing.
    // Once shown, the survey will not be displayed for at least another month.
    const setDelightedSmartPricingSurvey = () => {
        try {
            window.delightedCsat.survey({
                email: customer.email,
                name: props.customerId,
                createdAt: new Date().toString(),
            });
        }
        catch (_a) {
            console.warn('Could not launch survey');
        }
    };
    const handleTurnOnSmartPricing = () => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_opt_in_button_selected', {
            property_id: props.propertyId,
        });
        setSmartPricingModalOpen(true);
    };
    const handleLearnMoreClick = () => {
        window.open('https://travelnest.freshdesk.com/support/solutions/articles/101000467596-smart-pricing', '_blank');
    };
    return (react_1.default.createElement(__1.LoaderGuard, { loading: (0, viewstate_1.combineViewStates)(propertyViewState, manualPricing.viewState, pricingDefaults.viewState, pricingTypeViewState) === viewstate_1.ViewState.LOADING ||
            smartPricingOptOutResyncLoading ||
            smartPricingRegionCheckLoading },
        react_1.default.createElement(CurrencyChoiceModal_1.CurrencyChoiceModal, { isOpen: !currencyChoiceMade, onCurrencyChosen: (choice) => {
                setChosenCurrency(choice);
                setCurrencyChoiceMade(true);
            }, onClose: (choiceMade) => {
                if (!choiceMade) {
                    logging_1.logging.warn('User _must_ make a currency choice to complete the pricing task');
                    // Trigger the parent of the iframe to go back
                    parent.history.back();
                }
            } }),
        react_1.default.createElement(Generator_1.ModalGeneratorContainer, { propertyId: props.propertyId, currency: chosenCurrency, defaultPrice: chosenDefaultPrice, hasExistingPricing: hasExistingPricing, currentPricingEnd: pricingValidation && pricingValidation.end
                ? new diem_1.default(pricingValidation.end)
                : undefined, isOpen: generatorModalOpen, onCloseTap: () => setGeneratorModalOpen(false), onPricingGenerated: (generatedPricing) => {
                if (hasExistingPricing) {
                    const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)((0, helpers_2.splicePricingTogether)(manualPricing.pricing, generatedPricing));
                    manualPricing.update(updatedDepartureDays);
                }
                else {
                    (0, fullStory_1.sendCustomFullStoryEvent)('pricing_input_method', {
                        generated: true,
                    });
                    manualPricing.update(generatedPricing);
                }
            } }),
        react_1.default.createElement(smart_pricing_modals_1.SmartPricingModal, { currency: chosenCurrency, isOpen: smartPricingModalOpen, propertyId: props.propertyId, onClose: () => {
                setSmartPricingModalOpen(false);
            }, experimentSyncRate: smartPricingValue, updateDefaults: pricingDefaults.update, updatePricingType: updatePricingType }),
        react_1.default.createElement(smart_pricing_modals_1.SmartPricingOptOutModal, { isOpen: smartPricingOptOutModalOpen, propertyId: props.propertyId, onClose: () => {
                setSmartPricingOptOutModalOpen(false);
            }, optOutOfSmartPricing: () => {
                setSmartPricingOptOutResyncLoading(true);
                setCurrencyChoiceMade(false);
                updatePricingType(Object.assign(Object.assign({}, pricingType), { type: 'manual' }));
                (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_turned_off', {
                    property_id: props.propertyId,
                });
                setDelightedSmartPricingSurvey();
            } }),
        pricingTypePageMode() === 'SMART_EDIT' && (react_1.default.createElement(SmartPricingEdit_1.SmartPricingEdit, { pricingDefaults: pricingDefaults.defaults, onChange: (nextEdit) => {
                pricingDefaults.update(nextEdit);
            }, onExit: () => {
                setEditingDefaults(false);
            } })),
        pricingTypePageMode() === 'SMART' && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.PRICING, property: property, viewState: (0, viewstate_1.combineViewStates)(propertyViewState, manualPricing.viewState, pricingDefaults.viewState, pricingTypeViewState), lastSaved: pricingDefaults.lastSaved, getterError: pricingDefaults.getterError, updaterError: pricingDefaults.updaterError },
                react_1.default.createElement(TaskPage_1.TaskLayout, { width: 100 },
                    react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
                    react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    react_1.default.createElement(TaskPage_1.TaskColumn, null,
                        react_1.default.createElement(MarginWrapper_1.MarginWrapper, null,
                            react_1.default.createElement(SmartPricingSummary_1.SmartPricingSummary, { minPrice: pricingDefaults.defaults.min_price, currency: pricingDefaults.defaults
                                    .currency, onEditClicked: (_) => setEditingDefaults(true) }),
                            react_1.default.createElement(SmartPricingRecapDataWrapper, null,
                                react_1.default.createElement(SmartPricingRecapData_1.SmartPricingRecapData, { recapData: (0, pricing_helpers_1.calculateSmartPricingStats)(smartPricing, pricingDefault, pricingOverrides), currency: ((_a = pricingDefaults === null || pricingDefaults === void 0 ? void 0 : pricingDefaults.defaults) === null || _a === void 0 ? void 0 : _a.currency) || 'GBP' })),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            react_1.default.createElement(merlin_info_panels_1.DidYouKnow, { id: "smart-pricing-calendar-info-panel", icon: calendar_svg_1.default, colour: {
                                    background: '#F4F6F9',
                                    text: '#535D6A',
                                }, text: react_1.default.createElement("p", null,
                                    "You can review and override your nightly prices from",
                                    ' ',
                                    react_1.default.createElement(react_router_dom_1.Link, { to: `/property/${property === null || property === void 0 ? void 0 : property.id}/${appMode}/tasks/availability` }, "the calendar")) }),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            react_1.default.createElement(Button_1.Button, { onClick: () => setSmartPricingOptOutModalOpen(true) }, "Turn off smart pricing"))))))),
        pricingTypePageMode() === 'MANUAL_EDIT' && editingPeriod && (react_1.default.createElement(PricingPeriodPage_1.PricingPeriodPage, { propertyName: property.internal_name, pricingPeriod: editingPeriod, otherPricing: otherPeriods || [], onChange: (nextEdit) => {
                setEditingPeriod(nextEdit);
                const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)([
                    ...(otherPeriods || []),
                    nextEdit,
                ]);
                manualPricing.update(updatedDepartureDays);
            }, onReplacePricing: (newPricing, newPeriod, newOtherPeriods) => {
                const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)(newPricing);
                manualPricing.update(updatedDepartureDays);
                setEditingPeriod(newPeriod);
                setOtherPeriods(newOtherPeriods);
            }, onRemoveClicked: (_) => {
                const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)([
                    ...(otherPeriods || []),
                ]);
                manualPricing.update(updatedDepartureDays);
                setEditingPeriod(null);
                setOtherPeriods(null);
            }, onExit: () => {
                setEditingPeriod(null);
            } })),
        pricingTypePageMode() === 'MANUAL' && (react_1.default.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.PRICING, property: property, viewState: (0, viewstate_1.combineViewStates)(propertyViewState, manualPricing.viewState, pricingDefaults.viewState, pricingTypeViewState), lastSaved: manualPricing.lastSaved, getterError: manualPricing.getterError, updaterError: manualPricing.updaterError },
            react_1.default.createElement(TaskPage_1.TaskLayout, { width: 100 },
                react_1.default.createElement(TaskPage_1.TaskColumn, null,
                    react_1.default.createElement(MarginWrapper_1.MarginWrapper, null,
                        react_1.default.createElement(H2_1.H2, { text: "Recommended" }),
                        react_1.default.createElement(GradientInfoCard_1.GradientInfoCard, null,
                            !smartPricingRegionSupported && (react_1.default.createElement(hui_1.Chip, { text: "Coming soon", style: {
                                    marginBottom: '8px',
                                } })),
                            react_1.default.createElement("h3", null, "Smart pricing"),
                            react_1.default.createElement(P_1.P, null,
                                "Save time and enjoy effortless pricing. Earn ",
                                react_1.default.createElement("b", null, "up to 60% more"),
                                " in revenue by automatically adjusting prices according to local market trends."),
                            react_1.default.createElement(SmartPricingButtonContainer, null,
                                react_1.default.createElement(hui_1.Button, { text: smartPricingRegionSupported &&
                                        smartPricingTasksValid
                                        ? 'Turn on'
                                        : 'Learn more', variant: "positive", fill: "light", onClick: smartPricingRegionSupported &&
                                        smartPricingTasksValid
                                        ? handleTurnOnSmartPricing
                                        : handleLearnMoreClick, "data-test-id": "turn-on-smart-pricing-button" }),
                                smartPricingRegionSupported &&
                                    smartPricingTasksValid && (react_1.default.createElement(hui_1.Button, { text: "Learn more", variant: "secondary", fill: "clear", onClick: handleLearnMoreClick }))),
                            !smartPricingRegionSupported ? (react_1.default.createElement(P_1.P, null,
                                react_1.default.createElement("b", null, "We're working hard to make smart pricing available in your region. You'll be notified as soon as it becomes available."))) : (!smartPricingTasksValid && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(P_1.P, null,
                                    react_1.default.createElement("b", null, "Want to use smart pricing?")),
                                react_1.default.createElement(P_1.P, null, "There's just a few things you need to do before you turn it on:"),
                                react_1.default.createElement(SmartPricingChecklist_1.SmartPricingChecklist, { tasksValidation: smartPricingTasksValidation }))))),
                        react_1.default.createElement(H4_1.H4, { text: "Other ways to add pricing" }),
                        react_1.default.createElement(P_1.P, null, "Use our generator to create 24 months of pricing, or add pricing manually for any chosen time period. Pricing is automatically set to 100 per night when first generated."),
                        react_1.default.createElement(ButtonWrapper, null,
                            react_1.default.createElement(hui_1.Button, { variant: "primary", fill: "light", text: "Generate pricing", onClick: () => setGeneratorModalOpen(true) }),
                            react_1.default.createElement(hui_1.Button, { variant: "primary", fill: "light", text: "Add pricing manually", onClick: handleAddPeriodClick })),
                        manualPricing.pricing &&
                            manualPricing.pricing.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                            react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
                            react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                            react_1.default.createElement(Label_1.Label, { htmlFor: "pricing-periods" }, "Upcoming pricing periods"),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            react_1.default.createElement(Paragraph_1.Paragraph, null,
                                "Add or edit your nightly pricing, arrival days, 7 night stay discounts and minimum night stay within pricing periods. The nightly price is the total amount before commission (5% Travelnest fee + 15% channel commission).",
                                react_1.default.createElement("br", null),
                                "When pricing is changed it will go live on the channels immediately."),
                            react_1.default.createElement(Spacer_1.Spacer, { spacing: "smallest" }),
                            react_1.default.createElement(HelpLink_1.HelpLink, { to: "https://travelnest.freshdesk.com/support/solutions/articles/101000365067-how-to-add-and-amend-pricing" }, "Find out more about how to add and amend your pricing."),
                            react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                            react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            noCurrentOrFuturePricing && (react_1.default.createElement(InlineMessage_1.InlineError, { text: 'This property has no pricing' })),
                            currentPricingAndGapsList.map((p) => {
                                if ((0, helpers_2.isPricingPeriod)(p)) {
                                    const otherPricing = [
                                        ...(manualPricing.pricing ||
                                            []),
                                    ].filter((op) => !(0, lodash_1.isEqual)(p, op));
                                    const validation = (0, pricingPeriods_1.validatePricingPeriod)(p, otherPricing);
                                    return (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(PricingPeriodSummary_1.PricingPeriodSummary, { period: p, onEditClicked: (editPeriod) => {
                                                setEditingPeriod(editPeriod);
                                                setOtherPeriods(otherPricing);
                                            }, hasError: !validation.allValid }),
                                        react_1.default.createElement(PricingListSpacer, null)));
                                }
                                else {
                                    return (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(PricingPeriodGap_1.PricingPeriodGap, { start: new diem_1.default(p.start_date), end: new diem_1.default(p.end_date), onAddClicked: (start, end) => {
                                                const newPeriod = (0, helpers_2.newPricingPeriod)(props.propertyId, chosenCurrency, start, end);
                                                setEditingPeriod(newPeriod);
                                                setOtherPeriods(manualPricing.pricing);
                                                const updatedDepartureDays = (0, helpers_2.applyStaticDepartureDays)([
                                                    newPeriod,
                                                    ...(manualPricing.pricing ||
                                                        []),
                                                ]);
                                                manualPricing.update(updatedDepartureDays);
                                            } }),
                                        react_1.default.createElement(PricingListSpacer, null)));
                                }
                            }),
                            react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                            pricingValidation &&
                                pricingValidation.end &&
                                !noCurrentOrFuturePricing && (react_1.default.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'pricing-runs-out', text: `Your pricing ends on ${(0, helpers_2.humanizeDateFormat)(pricingValidation.end)}. Add more pricing to ensure guests can book your property into the future.` })),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            react_1.default.createElement(AddPeriodButton, { text: "Add pricing period" }),
                            react_1.default.createElement(Spacer_1.Spacer, null),
                            pastPricingSorted.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(Button_1.Button, { onClick: () => setShowPastPricingPeriods(!showPastPricingPeriods) }, `${showPastPricingPeriods
                                    ? 'Hide'
                                    : 'Show'} past pricing periods`),
                                react_1.default.createElement(Spacer_1.Spacer, { spacing: "large" }),
                                react_1.default.createElement(HorizontalRule_1.HorizontalRule, null),
                                react_1.default.createElement(Spacer_1.Spacer, null))),
                            showPastPricingPeriods &&
                                pastPricingSorted.map((p, idx, allPricing) => {
                                    const otherPricing = [
                                        ...allPricing,
                                    ];
                                    otherPricing.splice(idx, 1);
                                    const validation = (0, pricingPeriods_1.validatePricingPeriod)(p, otherPricing);
                                    return (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(PricingPeriodSummary_1.PricingPeriodSummary, { period: p, onEditClicked: (editPeriod) => {
                                                const rest = manualPricing.pricing.filter((fp) => !(0, lodash_1.isEqual)(fp, editPeriod));
                                                setEditingPeriod(editPeriod);
                                                setOtherPeriods(rest);
                                            }, hasError: !validation.allValid }),
                                        react_1.default.createElement(PricingListSpacer, null)));
                                }))))))))));
};
//# sourceMappingURL=PricingPage.js.map